module.exports = __webpack_public_path__ + "static/media/arrow.69d1e273.svg";